/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { isReducedMotion } from '../utils/is-reduced-motion';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { useIsReducedMotion } from '../utils/use-is-reduced-motion';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { prefersReducedMotion } from '../utils/accessibility';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { reduceMotionAsPerUserPreference } from '../utils/reduce-motion-as-per-user-preference';
